import * as _ from "lodash";
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO";
import {IMessageProvider, IProgressProvider} from "../PA.Core/PA.Core.IF.Basic";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {
    WB_ModelCoefficientSetCRRow,
    WB_ModelCoefficientSetRow,
    WB_ModelCoefficientSetRRow, WB_ModelCoefficientSetTRRow,
    WB_ModelCoeffSetConstRRow,
    WB_ModelingSessionConstantRRow,
    WB_ModelingSessionRow,
    WB_ModelingSessionTermRRow,
    WB_ModelRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbModelCoefficientSet, IwbModelingSessionConstantR, IwbModelingSessionRefR} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Customer,
    esWB_Finished_Product,
    esWB_Model,
    esWB_Model_Coeff_Set,
    esWB_Model_Coeff_SetCR,
    esWB_Model_Coeff_SetR,
    esWB_Model_Coeff_SetRR,
    esWB_Product_Group,
    esWB_Model_Coeff_SetConstR,
    esWB_Modeling_Session_ConstantR,
    esWB_Model_Coeff_SetTR,
    esWB_Modeling_Session,
    esWB_Modeling_Session_El,
    esWB_Modeling_Session_Coeff_Grp,
    esWB_Modeling_Session_ConstantFR,
    esWB_Modeling_Session_Trial,
    esWB_Modeling_Session_Range,
    esWB_Modeling_Session_Trial_Metric,
    esWB_Modeling_Session_AffinitySet_Relationship,
    esWB_Modeling_Session_Coeff_Rule,
    esWB_Modeling_Session_Observation,
    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship,
    esWB_Modeling_Session_Tag_RuleR,
    esWB_Modeling_Session_Reference_Predictor_Relationship,
    esWB_Modeling_Session_Log,
    esWB_Modeling_Session_ElCR,
    esWB_Modeling_Session_ElR,
    esWB_Modeling_Session_Cannibalization_Type_Relationship,
    esWB_Modeling_Session_TermR,
    esWB_Modeling_Session_Reference_Relationship,
    esWB_Model_Coefficient,
    esWB_Model_Term_Relationship,
    esWB_Model_Cannibalization_Relationship,
    esWB_Model_Predictor,
    esWB_Model_Function,
    esWB_Modeling_Session_CustR,
    esWB_Modeling_Session_ProdR
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {IHaveModel} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {ModelBO} from "./ModelBO";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ModelUtils} from "../PA.Model.Services/ModelUtils";
import {ModelingSessionBO} from "./ModelingSessionBO";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";


export interface IModelCoefficientSetCopyOptions {
    CoeffSetId?: number,
    ModelId?: number,
    Name?: string,
    ModelingSessionTrialId?: number,
    ModelingSessionId?: number
}

const ModelCoefficientSetCopyOptions_default: IModelCoefficientSetCopyOptions = {}

export class ModelCoefficientSetBO
    implements IBusinessObject,
        IHaveModel {
    Identity: IdentityProvider;

    CreateOptions: any;
    CopyOptions: IModelCoefficientSetCopyOptions

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ModelCoefficientSet: WB_ModelCoefficientSetRow

    constructor(options?: any) {
        this.CreateOptions = options || {};

        if ("dbContext" in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: "New Model Coefficient Set"});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider("Loading", this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);
        this.drWB_ModelCoefficientSet = null;

        this.IHaveModel_init()
    }

    get WB_ModelCoefficientSet(): WB_ModelCoefficientSetRow {
        return this.drWB_ModelCoefficientSet;
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating ModelCoefficient Set");
        let createOpts = _.defaultsDeep({}, self.CreateOptions, options)
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {
            self.LoadOptions = options || {};
            if ("dbContext" in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                var sError = "Unable to determine dbContext for new ModelCoefficient Set.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            var aModelRow: WB_ModelRow = undefined
            self.dbContext.find(esWB_Model, createOpts.ModelId)
                .then((aModelRecord: WB_ModelRow) => {
                    if (aModelRecord == null) {
                        // Bad Cust ID
                        resolve(self)
                        return
                    }
                    aModelRow = aModelRecord
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_Model_Coeff_Set);
                })
                .then((modelCoefficientSetRow: WB_ModelCoefficientSetRow) => {
                    debugger
                    modelCoefficientSetRow.setDefaults();
                    self.drWB_ModelCoefficientSet = modelCoefficientSetRow;
                    self.drWB_ModelCoefficientSet.cif.WB_MODEL_ID = createOpts.ModelId;
                    self.drWB_ModelCoefficientSet.WB_ModelRow = aModelRow;
                    self.drWB_ModelCoefficientSet.cif.WB_MODELING_SESSION_ID = createOpts.ModelingSessionId
                    self.drWB_ModelCoefficientSet.cif.WB_MODELING_SESSION_TRIAL_ID = createOpts.ModelingSessionTrialId
                    self.drWB_ModelCoefficientSet.cif.MODEL_COEFF_SET_NAME = _.isEmpty(createOpts.Name) ? "" : createOpts.Name
                    //add this to all the BOs
                    self.dbContext.add(esWB_Model_Coeff_Set, modelCoefficientSetRow);

                    self.Identity.setAll(
                        self.drWB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID,
                        self.drWB_ModelCoefficientSet.cif.MODEL_COEFF_SET_ID,
                        self.drWB_ModelCoefficientSet.cif.MODEL_COEFF_SET_NAME
                    );
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    );
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelCoefficientSet,
                        "WB_MODEL_COEFF_SET_ID",
                        "MODEL_COEFF_SET_ID",
                        "MODEL_COEFF_SET_NAME"
                    );
                    return self.drWB_ModelCoefficientSet.loadRelations([esWB_Model])
                })
                .then((ignore) => {
                    return self._AfterBoLoadCompleteInternal()
                })
                .then((ignore) => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch(err => {
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        var self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        if (!this.bIsLoaded)
            this.Identity.setAll(anId, anId, "Loading Model Coefficient Set (" + anId + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, reject) => {
            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                var sError = "Model Coefficient Set already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if ("dbContext" in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Model Coefficient Set.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }
            //Added for record resolver
            if ("RecordResolver" in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve();
            } else {
                recordResolver = ModelCoefficientSetBO.createRecordResolver({
                    dbContext: self.dbContext
                });
                recordResolverLoadPromise = ModelCoefficientSetBO.setupRecordResolver(
                    recordResolver,
                    [anId]
                );
            }

            recordResolverLoadPromise
                .then(function () {
                    let newModelCoefficientSetRow: any = recordResolver.get(
                        esWB_Model_Coeff_Set,
                        anId
                    );

                    if (_.isEmpty(newModelCoefficientSetRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_ModelCoefficientSet = newModelCoefficientSetRow;
                    self.Identity.setAll(
                        self.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID,
                        self.WB_ModelCoefficientSet.cif.MODEL_COEFF_SET_ID,
                        self.WB_ModelCoefficientSet.cif.MODEL_COEFF_SET_NAME
                    );
                    self.LoadProgressProvider.setName(
                        "Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")"
                    );
                    self.Identity.listenToRecordUpdates(
                        self.WB_ModelCoefficientSet,
                        "WB_MODEL_COEFF_SET_ID",
                        "MODEL_COEFF_SET_ID",
                        "MODEL_COEFF_SET_NAME"
                    );

                    return self._AfterBoLoadCompleteInternal()
                })
                .then((newModelCoefficientSetRow: any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                    return;
                });
        });

        return this._OnLoadComplete;
    }

    _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        return new Promise<void>((resolve, error) => {
            let tasks: Promise<any>[] = [];
            self.LoadProgressProvider.setProgressMessage('ModelDataSet.PostLoad', 'Processing Loaded Data');
            tasks.push(self.OnIHaveModelLoaded)
            Promise.all(tasks)
                .then((ignore) => {
                    resolve();
                })
                .catch((err: any) => {
                    error(err);
                });
        })
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {
        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start(
            "Validating " +
            self.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID +
            "(" +
            self.WB_ModelCoefficientSet.cif.MODEL_COEFF_SET_ID +
            ")"
        );
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Model Coefficient Set.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options);
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options);
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbModelCoefficientSet = <IwbModelCoefficientSet>self.WB_ModelCoefficientSet;
        this.SaveProgressProvider.start(
            "Saving " +
            wbModelCoefficientSet.MODEL_COEFF_SET_NAME +
            "(" +
            wbModelCoefficientSet.MODEL_COEFF_SET_ID +
            ")"
        );

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Model Coefficient Set.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return;
            }
            self.SaveOptions = options || {};

            var saveFunction: (
                esName: string,
                saveRecords: ESRecord[] | ESRecord,
                options?: any
            ) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            saveFunction(esWB_Model_Coeff_Set, self.drWB_ModelCoefficientSet, {})
                .then(() => {
                    let tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_Model_Coeff_SetR, self.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRows))
                    tasks.push(saveFunction(esWB_Model_Coeff_SetRR, self.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRRows))
                    tasks.push(saveFunction(esWB_Model_Coeff_SetCR, self.WB_ModelCoefficientSet.WB_ModelCoefficientSetCRRows))
                    tasks.push(saveFunction(esWB_Model_Coeff_SetConstR, self.WB_ModelCoefficientSet.WB_ModelCoeffSetConstRRows))
                    tasks.push(saveFunction(esWB_Model_Coeff_SetTR, self.WB_ModelCoefficientSet.WB_ModelCoefficientSetTRRows))
                })
                .then(ignored => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                            LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.getLeaseClass(LeaseRegistry.Lease_Subject_CoefficientSet, wbModelCoefficientSet.WB_MODEL_COEFF_SET_ID));
                        });
                    } else {
                        self._bIsSaved = true;
                        LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.getLeaseClass(LeaseRegistry.Lease_Subject_CoefficientSet, wbModelCoefficientSet.WB_MODEL_COEFF_SET_ID));
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch(err => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self);
                });
        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    Copy(options?: any): Promise<IBusinessObject> {


        const self: ModelCoefficientSetBO = this;

        let copyOptions = _.defaultsDeep({}, self.CopyOptions, options)

        return new Promise<ModelCoefficientSetBO>(async (resolve, error) => {
            let newTargetBO = new ModelCoefficientSetBO({
                dbContext: self.dbContext,
                ModelId: copyOptions.ModelId,
                ModelingSessionTrialId: copyOptions.ModelingSessionTrialId,
                ModelingSessionId: copyOptions.ModelingSessionId

            });

            try {
                await newTargetBO.LoadNew({
                    dbContext: self.dbContext,
                    ModelId: copyOptions.ModelId,
                    Name: copyOptions.Name
                })
                await self.UpdateCoefficientSet(newTargetBO, copyOptions.ModelingSessionId, undefined, undefined, true)
                resolve(newTargetBO)
            } catch (err) {
                console.log('ModelCoefficientSetBO creation failed:')
                console.log(err);
                error(err)
            }
        })

    }

    async loadSessionBO(wbSessionID: number): Promise<IBusinessObject> {
        const self = this
        let bo: ModelingSessionBO = new ModelingSessionBO(self.dbContext)
        return await bo.Load(wbSessionID)
    }

    async loadSessionSet(wbSetID: number): Promise<IBusinessObject> {
        let aSet = new ModelCoefficientSetBO()
        return await aSet.Load(wbSetID)
    }

    async getCoefficients(wbModelID: number): Promise<number> {
        const self = this
        let cntCoeff = 0
        let arrCoeff = await ModelUtils.getModelCoefficientList(wbModelID, {
            bSkipCache: true,
            dbContext: self.dbContext
        })
        cntCoeff = arrCoeff.length
        arrCoeff = await ModelUtils.getModelCannCoefficientList(wbModelID, {
            bSkipCache: true,
            dbContext: self.dbContext
        })
        cntCoeff += arrCoeff.length
        return cntCoeff
    }

    async copyRefValues(srcSessionRow: WB_ModelingSessionRow, boSet: ModelCoefficientSetBO, bCopy: boolean): Promise<ModelCoefficientSetBO> {
        if (!bCopy)
            _.forEach(_.filter(boSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive), (aXrefRow: WB_ModelCoefficientSetRRow) => {
                aXrefRow.markDeleted()
            })

        for (let Idx = 0; Idx < _.filter(srcSessionRow.WB_ModelingSessionRefRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive).length; Idx++) {
            let sourceXref = srcSessionRow.WB_ModelingSessionRefRRows[Idx]
            await boSet.addCoeffSetRR(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID, boSet.dbContext, sourceXref)
        }
        return boSet

    }

    async copySequential(sourceSet: WB_ModelCoefficientSetRow, boSet: ModelCoefficientSetBO, bCopy?: boolean): Promise<ModelCoefficientSetBO> {
        if (!bCopy) {
            _.forEach(_.filter(boSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive), (aXrefRow: WB_ModelCoefficientSetRRow) => {
                aXrefRow.markDeleted()
            })

            _.forEach(_.filter(boSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetCRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive), (aXrefRow: WB_ModelCoefficientSetCRRow) => {
                aXrefRow.markDeleted()
            })

        }

        for (let Idx = 0; Idx < _.filter(sourceSet.WB_ModelCoefficientSetRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive).length; Idx++) {
            let sourceXref = sourceSet.WB_ModelCoefficientSetRRows[Idx]
            await boSet.addCoeffSetR(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID, boSet.dbContext, sourceXref)
        }

        for (let Idx = 0; Idx < _.filter(sourceSet.WB_ModelCoefficientSetCRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive).length; Idx++) {
            let sourceXref = sourceSet.WB_ModelCoefficientSetCRRows[Idx]
            await boSet.addCoeffSetCR(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID, boSet.dbContext, sourceXref)
        }


        return boSet
    }

    async copyTerms(wbModelingSessionId: number, boSet: ModelCoefficientSetBO, bCopy: boolean): Promise<ModelCoefficientSetBO> {
        if (!bCopy) {
            _.forEach(_.filter(boSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetTRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive), (aTRRow: WB_ModelCoefficientSetTRRow) => {
                aTRRow.markDeleted()
            })

        }

        const modelingSessionTermRRows: WB_ModelingSessionTermRRow[] = await boSet.dbContext.findAll(esWB_Modeling_Session_TermR, {
            where: {
                DELETED_IND: {neq: '1'},
                WB_MODELING_SESSION_ID: wbModelingSessionId
            }
        })

        for (let Idx = 0; Idx < modelingSessionTermRRows.length; Idx++) {
            let aTermRRow = modelingSessionTermRRows[Idx]
            await boSet.addCoeffSetTR(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID, boSet.dbContext, aTermRRow)
        }


        return boSet
    }

    async copyConstants(wbModelingSessionId: number, boSet: ModelCoefficientSetBO, bCopy: boolean): Promise<ModelCoefficientSetBO> {
        if (!bCopy)
            _.forEach(_.filter(boSet.WB_ModelCoefficientSet.WB_ModelCoeffSetConstRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive), (aXrefRow: WB_ModelCoeffSetConstRRow) => {
                aXrefRow.markDeleted()
            })

        const wbModelingSessionConstantRRows: WB_ModelingSessionConstantRRow[] = await boSet.dbContext.findAll(esWB_Modeling_Session_ConstantR, {
            where: {
                DELETED_IND: {neq: '1'},
                WB_MODELING_SESSION_ID: wbModelingSessionId
            }
        })

        for (let Idx = 0; Idx < _.filter(wbModelingSessionConstantRRows, aRow => aRow.cif.DELETED_IND != '1' && aRow.isActive).length; Idx++) {
            let sourceXref = wbModelingSessionConstantRRows[Idx]
            await boSet.addCoeffSetConstR(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_COEFF_SET_ID, boSet.dbContext, sourceXref)
        }
        return boSet

    }

    async UpdateCoefficientSet(boSet: ModelCoefficientSetBO, wbModelingSessionId: number, sourceSetID: number, wbTrialID?: number, bCopy?: boolean): Promise<ModelCoefficientSetBO> {
        const self = this
        let sourceSetRow: WB_ModelCoefficientSetRow = undefined
        if (bCopy) {
            sourceSetRow = self.WB_ModelCoefficientSet
        } else {
            let srcSetBO: any = await self.loadSessionSet(sourceSetID)
            sourceSetRow = srcSetBO.WB_ModelCoefficientSet
        }
        let srcSessionBO: ModelingSessionBO = <ModelingSessionBO>await self.loadSessionBO(sourceSetRow.cif.WB_MODELING_SESSION_ID)


        boSet.WB_ModelCoefficientSet.cif.R2_TOTAL = sourceSetRow.cif.R2_TOTAL
        boSet.WB_ModelCoefficientSet.cif.MAPE_TOTAL = sourceSetRow.cif.MAPE_TOTAL
        boSet.WB_ModelCoefficientSet.cif.AFFINITY_SET_COUNT = srcSessionBO.AffinitySets.length
        boSet.WB_ModelCoefficientSet.cif.CUSTOMER_COUNT = _.filter(srcSessionBO.WB_ModelingSession.WB_ModelingSessionCustRRows, aRow => aRow.isActive).length
        boSet.WB_ModelCoefficientSet.cif.PRODUCT_COUNT = _.filter(srcSessionBO.WB_ModelingSession.WB_ModelingSessionProdRRows, aRow => aRow.isActive).length
        boSet.WB_ModelCoefficientSet.cif.COEFFICIENT_COUNT = await self.getCoefficients(boSet.WB_ModelCoefficientSet.cif.WB_MODEL_ID)
        if (!_.isUndefined(wbTrialID))
            boSet.WB_ModelCoefficientSet.cif.WB_MODELING_SESSION_TRIAL_ID = wbTrialID

        boSet = await self.copyRefValues(srcSessionBO.WB_ModelingSession, boSet, bCopy)
        boSet = await self.copySequential(sourceSetRow, boSet)
        boSet = await self.copyConstants(wbModelingSessionId, boSet, bCopy)
        boSet = await self.copyTerms(wbModelingSessionId, boSet, bCopy)
        boSet.Save()
        return boSet
    }

    addCoeffSetR(newSetId: number, dbContext: PAdbContext, sourceRow: WB_ModelCoefficientSetRRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Model_Coeff_SetR)
                .then((aNewRow: WB_ModelCoefficientSetRRow) => {
                    for (let key in sourceRow) {
                        if (key !== 'WB_MODEL_COEFF_SETR_ID' && key.substr(0, 1) != "_" && key.substr(0, 1) != key.substr(0, 1).toLowerCase())
                            aNewRow.cif[key] = sourceRow.cif[key]
                    }

                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODEL_COEFF_SET_ID = newSetId
                    dbContext.add(esWB_Model_Coeff_SetR, aNewRow)
                    resolve()
                })
        })
    }


    addCoeffSetCR(newSetId: number, dbContext: PAdbContext, sourceRow: WB_ModelCoefficientSetCRRow): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Model_Coeff_SetCR)
                .then((aNewRow: WB_ModelCoefficientSetRRow) => {
                    for (let key in sourceRow) {
                        if (key !== 'WB_MODEL_COEFF_SETCR_ID' && key.substr(0, 1) != "_" && key.substr(0, 1) != key.substr(0, 1).toLowerCase())
                            aNewRow.cif[key] = sourceRow.cif[key]
                    }

                    aNewRow.setDefaults()
                    aNewRow.cif.WB_MODEL_COEFF_SET_ID = newSetId
                    dbContext.add(esWB_Model_Coeff_SetCR, aNewRow)
                    resolve()
                })
        })
    }

    addCoeffSetRR(newSetId: number, dbContext: PAdbContext, sourceRow: IwbModelingSessionRefR): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Model_Coeff_SetRR)
                .then((aNewRow: WB_ModelCoefficientSetRRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_CUST_ID = sourceRow.cif.WB_CUST_ID
                    aNewRow.cif.WB_PRDGRP_ID = sourceRow.cif.WB_PRDGRP_ID
                    aNewRow.cif.WB_PROD_ID = sourceRow.cif.WB_PROD_ID
                    aNewRow.cif.WB_MODEL_PREDICTOR_ID = sourceRow.cif.WB_MODEL_PREDICTOR_ID
                    aNewRow.cif.REF_VALUE = sourceRow.cif.REF_VALUE
                    aNewRow.cif.WB_MODEL_COEFF_SET_ID = newSetId
                    dbContext.add(esWB_Model_Coeff_SetRR, aNewRow)
                    resolve()
                })
        })
    }

    addCoeffSetConstR(newSetId: number, dbContext: PAdbContext, sourceRow: IwbModelingSessionConstantR): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Model_Coeff_SetConstR)
                .then((aNewRow: WB_ModelCoeffSetConstRRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_CUST_ID = sourceRow.cif.WB_CUST_ID
                    aNewRow.cif.WB_PRDGRP_ID = sourceRow.cif.WB_PRDGRP_ID
                    aNewRow.cif.WB_PROD_ID = sourceRow.cif.WB_PROD_ID
                    aNewRow.cif.WB_MODEL_COEFF_SET_ID = newSetId
                    aNewRow.cif.WB_MODEL_CONSTANT_ID = sourceRow.cif.WB_MODEL_CONSTANT_ID
                    aNewRow.cif.INDEX = sourceRow.cif.INDEX
                    aNewRow.cif.CONSTANT_VALUE = sourceRow.cif.CONSTANT_VALUE

                    dbContext.add(esWB_Model_Coeff_SetConstR, aNewRow)
                    resolve()
                })
        })
    }

    addCoeffSetTR(newSetId: number, dbContext: PAdbContext, sourceRow: WB_ModelingSessionTermRRow): Promise<WB_ModelCoefficientSetTRRow> {
        const self = this

        return new Promise<WB_ModelCoefficientSetTRRow>((resolve, error) => {

            self.dbContext.createRecordWithKey(esWB_Model_Coeff_SetTR)
                .then((aNewRow: WB_ModelCoefficientSetTRRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_CUST_ID = sourceRow.cif.WB_CUST_ID
                    aNewRow.cif.WB_PRDGRP_ID = sourceRow.cif.WB_PRDGRP_ID
                    aNewRow.cif.WB_PROD_ID = sourceRow.cif.WB_PROD_ID
                    aNewRow.cif.WB_MODEL_COEFF_SET_ID = newSetId
                    aNewRow.cif.WB_MODEL_TERM_ID = sourceRow.cif.WB_MODEL_TERM_ID
                    aNewRow.cif.NEUTRALIZED_IND = sourceRow.cif.NEUTRALIZED_IND

                    dbContext.add(esWB_Model_Coeff_SetTR, aNewRow)
                    resolve(aNewRow)
                })
        })
    }

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options);
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options);
    }

    private DeleteUsing(
        bSaveNow: boolean,
        options?: any
    ): Promise<IBusinessObject> {
        var self = this;
        var wbModelCoefficientSet = <IwbModelCoefficientSet>self.drWB_ModelCoefficientSet;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start(
            "Deleting " + wbModelCoefficientSet.MODEL_COEFF_SET_NAME + "(" + wbModelCoefficientSet.MODEL_COEFF_SET_ID + ")"
        );
        return new Promise<IBusinessObject>((resolve, error) => {
            // 1. Validate if we can delete the Meta

            // 2. If Valid, mark all the records for deletion.
            _.forEach(self.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRows, aRow => {
                aRow.markDeleted()
            })

            self.drWB_ModelCoefficientSet.markDeleted();

            if (bSaveNow) {
                self
                    .SaveUsing(false)
                    .then(ignore => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch(err => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self);
                    });
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHaveModel_init() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
        this._Model = undefined
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this

        if (this._OnIHaveModelLoaded) {
            return this._OnIHaveModelLoaded
        }

        let returnValue = new Promise<void>((resolve, error) => {
            let wbModelId = self.WB_ModelCoefficientSet.cif.WB_MODEL_ID
            if (!(wbModelId > 0)) {
                resolve()
                return
            }
            let aModel = new ModelBO()
            aModel.Load(wbModelId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._Model = aModel
                    self._bIHaveModelLoaded = true
                    resolve()
                })
                .catch((err) => {
                    resolve()
                })

        })
        this._OnIHaveModelLoaded = returnValue

        return returnValue
    }

    get Model(): ModelBO {
        return this._Model
    }

    //</editor-fold>


    //<editor-fold desc="IHaveRecordResolver -- static">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {
        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ("dbContext" in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const modelCoefficientSet_options: CreateOptions = {
            standardConditions: {
                [esWB_Model_Coeff_SetRR]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {[esWB_Model_Coeff_SetRR]:[esWB_Customer,esWB_Product_Group, esWB_Finished_Product]}
        };

        const aRecResolver = new ESRecordResolver(dbContext, modelCoefficientSet_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {
        return new Promise<void>((resolve, error) => {
            recordResolver
                .findAllWithRelationships(esWB_Model_Coeff_Set, ids)
                .then(result => {
                    resolve();
                })
                .catch(err => {
                    error(err);
                });
        });
    }

    //</editor-fold>

}

PAEnvironment.registerBusinessObjectClass(ModelCoefficientSetBO, "ModelCoefficientSetBO", "Model Coefficient Set")